import { render, staticRenderFns } from "./AddColumnsGrid.vue?vue&type=template&id=0edb84f8&scoped=true"
import script from "./AddColumnsGrid.vue?vue&type=script&lang=js"
export * from "./AddColumnsGrid.vue?vue&type=script&lang=js"
import style0 from "./AddColumnsGrid.vue?vue&type=style&index=0&id=0edb84f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb84f8",
  null
  
)

export default component.exports